'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { stack } from '@flipster/styled-system/patterns';

import { LoadingPage } from '../loading-page';
import { copyTradingBunja } from '../shared/copy-trading/state';
import { CopyTradingHomeSegmentView } from './event';
import { Header } from './section/1-header';
import { MeetMasterTrader, MeetMasterTraderSingleContainer } from './section/2-meet-master-trader';
import { Faq } from './section/3-faq';

export const CopyTradingPage = () => {
  const { isLoadingAtom } = useBunja(copyTradingBunja);
  const isLoading = useAtomValue(isLoadingAtom);
  if (isLoading) return <LoadingPage />;
  return (
    <main
      className={stack({
        minH: 'minHeightWithoutNavigation',
        tabletDown: {
          py: 32,
        },
        tablet: {
          pb: 80,
        },
        gap: { base: 32, tablet: 96 },
      })}
    >
      <CopyTradingHomeSegmentView />
      <Header
        css={{
          w: '100%',
          mx: 'auto',
          maxW: 'desktopMaxWidth',
          smallDesktop: {
            boxSizing: 'content-box',
          },
          px: { base: 16, tablet: 32 },
        }}
      />
      <MeetMasterTraderSingleContainer>
        <MeetMasterTrader
          css={{
            w: '100%',
            mx: 'auto',
            maxW: 'desktopMaxWidth',
            smallDesktop: {
              boxSizing: 'content-box',
            },
            px: { base: 16, tablet: 32 },
          }}
        />
      </MeetMasterTraderSingleContainer>
      <Faq
        css={{
          w: '100%',
          mx: 'auto',
          maxW: 'desktopMaxWidth',
          smallDesktop: {
            boxSizing: 'content-box',
          },
          px: { base: 16, tablet: 32 },
        }}
      />
    </main>
  );
};
